import { useTheme } from '@material-ui/core';
import { useState, useEffect } from 'react';
import { AiIcon } from '../../../Icons';
import { BooleanFilter } from '../../../WbTableFilters';
import { useGeneralPurposePickerContext } from '../../GeneralPurposePickerContext';

interface AiToggleProps {
  handleChange: (value?: boolean) => void;
  aiFilterButtonClass?: string;
}

export const AiToggle: React.FC<AiToggleProps> = ({
  handleChange,
  aiFilterButtonClass,
}) => {
  const theme = useTheme();
  const { aiState, bestMatchState } = useGeneralPurposePickerContext();

  const [showIcon, setShowIcon] = useState(true);

  useEffect(() => {
    let interval: NodeJS.Timeout | undefined;
    if (bestMatchState.loading) {
      setShowIcon(true);
      interval = setInterval(() => {
        setShowIcon(prev => !prev);
      }, 1000);
    } else {
      setShowIcon(true);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [bestMatchState.loading]);

  const fadeStyle: React.CSSProperties = {
    transition: 'opacity 0.5s',
    opacity: showIcon ? 1 : 0,
    display: 'inline-flex',
    alignItems: 'center',
  };

  return (
    <BooleanFilter
      className={aiFilterButtonClass}
      color={theme.palette.accent.main}
      startIcon={
        <span style={fadeStyle}>
          <AiIcon style={{ color: theme.palette.accent.main }} />
        </span>
      }
      value={aiState}
      field={bestMatchState.loading ? 'Please wait...' : 'Witty Best Match'}
      disabled={bestMatchState.loading}
      onChange={handleChange}
    />
  );
};
